/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext } from "react";

const BannerContext = createContext({
  openBanners: [""],
  // eslint-disable-next-line no-unused-vars
  handleAddBannerToOpenBanners: (bannerName: string) => {},
  // eslint-disable-next-line no-unused-vars
  handleRemoveBannerFromOpenBanners: (bannerName: string) => {},
});

export { BannerContext };
